import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Calendar, User, ArrowRight } from 'lucide-react';
import ReactMarkdown from 'react-markdown';
import BlogHeader from './BlogHeader';
import { blogPosts } from '../data/blogPosts';
import './BlogList.css';

const BlogList = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Use generated blog posts data
    setPosts(blogPosts);
    setLoading(false);
  }, []);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  if (loading) {
    return (
      <div className="blog-list">
        <div className="container">
          <div className="blog-loading">
            <div className="loading-spinner"></div>
            <p>Loading blog posts...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="blog-list">
      <BlogHeader />
      <div className="container">
        <div className="blog-page-header">
          <h1>Agent You Blog</h1>
          <p>Insights, tutorials, and updates about AI agents and the future of knowledge sharing</p>
        </div>

        <div className="blog-posts">
          {posts.map((post) => (
            <article key={post.slug} className={`blog-post-card ${post.featured ? 'featured' : ''}`}>
              {post.featured && <div className="featured-badge">Featured</div>}
              
              <div className="post-meta">
                <div className="post-date">
                  <Calendar size={16} />
                  <span>{formatDate(post.date)}</span>
                </div>
                <div className="post-author">
                  <User size={16} />
                  <span>{post.author}</span>
                </div>
              </div>

              <h2 className="post-title">
                <Link to={`/blog/${post.slug}`}>{post.title}</Link>
              </h2>

              <div className="post-excerpt">
                <p>{post.excerpt}</p>
              </div>

              <div className="post-footer">
                <Link to={`/blog/${post.slug}`} className="read-more">
                  Read More
                  <ArrowRight size={16} />
                </Link>
              </div>
            </article>
          ))}
        </div>

        {posts.length === 0 && (
          <div className="no-posts">
            <h3>No blog posts yet</h3>
            <p>Check back soon for updates and insights!</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default BlogList;
